"use strict";

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var InternalLink = void 0;

try {
    InternalLink = require("@spp/ui-internal-link");
} catch (err) {
    // silent catch
}

if (InternalLink === undefined) {
    var React = require("react");
    InternalLink = function Link(_ref) {
        var href = _ref.link,
            enableSinglePage = _ref.enableSinglePage,
            rest = (0, _objectWithoutProperties3.default)(_ref, ["link", "enableSinglePage"]);

        return React.createElement("a", (0, _extends3.default)({ href: href }, rest));
    };
}

module.exports = InternalLink;
//# sourceMappingURL=Link.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/Link.js
 ** module id = 56
 ** module chunks = 1
 **/